import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { RequestLeaveReportDto, ResponseGetTypeLeaveDto, ResponseSendMailLeaveDto, RequestEmployeeListDownloadDto, RequestLeaveBalanceReportDto } from "../dto/report.dto";
import { ResponsePreviewDto } from "../dto/report-preview.dto";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class ReportApi {

  private service: string = '';
  private model: string = 'report';
  private timeoutDuration: number = (5 * 60) * 1000;

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getTypeLeave(data): Observable<ResponseGetTypeLeaveDto> {
    const method: string = 'GET';
    const func: string = 'leave/getTypeLeave';
    const params: any = {};
    const urlParams: any = {
      companyId: data
    };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTypeLeaveDto>(method, url, func, params, body, null, this.timeoutDuration);
  }

  public leaveDownloadExcel(data: RequestLeaveReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'leave/downloadExcel';
    const params: RequestLeaveReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }


  public leaveDownloadPdf(data: RequestLeaveReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'leave/downloadPdf';
    const params: RequestLeaveReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public leaveReportSendEmail(data: RequestLeaveReportDto): Observable<ResponseSendMailLeaveDto> {
    const method: string = 'POST';
    const func: string = 'leave/reportSendEmail';
    const params: RequestLeaveReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendMailLeaveDto>(method, url, params, urlParams, body, null, this.timeoutDuration);
  }

  public employeeListPreview(data: RequestEmployeeListDownloadDto) {
    const method: string = 'POST';
    const func: string = 'employee/preview';
    const params: RequestEmployeeListDownloadDto = data;
    const urlParams: any = {};
    const body: any = {};
    const timeout: number = (5 * 60) * 1000;
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponsePreviewDto>>(method, url, params, urlParams, body, null, timeout);
  }

  public employeeSendMail(data: RequestEmployeeListDownloadDto) {
    const method: string = 'POST';
    const func: string = 'employee/reportSendEmail';
    const params: RequestEmployeeListDownloadDto = data;
    const urlParams: any = {};
    const body: any = {};
    const timeout: number = (5 * 60) * 1000;
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponsePreviewDto>>(method, url, params, urlParams, body, null, timeout);
  }

  public employeeListDownloadExcel(data: RequestEmployeeListDownloadDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'employee/downloadExcel';
    const params: RequestEmployeeListDownloadDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }


  public employeeListDownloadPdf(data: RequestEmployeeListDownloadDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'employee/downloadPdf';
    const params: RequestEmployeeListDownloadDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public leaveBalanceDownloadExcel(data: RequestLeaveBalanceReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'reportleaveBalance/downloadExcel';
    const params: RequestLeaveBalanceReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }


  public leaveBalanceDownloadPdf(data: RequestLeaveBalanceReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'reportleaveBalance/downloadPdf';
    const params: RequestLeaveBalanceReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public leaveBalanceReportSendEmail(data: RequestLeaveBalanceReportDto): Observable<ResponseSendMailLeaveDto> {
    const method: string = 'POST';
    const func: string = 'reportleaveBalance/reportSendEmail';
    const params: RequestLeaveBalanceReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendMailLeaveDto>(method, url, params, urlParams, body, null, this.timeoutDuration);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/report.api.ts